import React from 'react';

// Images
import gmail from './images/gmail.png';
import applemail from './images/applemail.png';
import yahoomail from './images/yahoomail.png';
import outlook from './images/outlook.png';

export default class ThankYou extends React.Component {
  render() {
    return (
      <div className="body">
        <div className="banner-panel banner-small">
          <div className="banner-overlay">
            <div className="gradient"></div>
          </div>
        </div>
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-md-8 text-center">
              <span className="final-step">!</span>
              <h3 className="small mt-4">Final step</h3>
              <h1 className="gradient-text no-hover mb-4 d-block">Check Your Emails</h1>
              <p>You will now receive an email within 0 - 5 minutes from each of the companies you selected. <strong>Your registration is NOT complete</strong> until you follow the instructions in these emails.</p>
            </div>
          </div>
          <div className="row text-center pt-3 pt-md-5 pb-3 justify-content-center">
            <div className="col-md-4">
              <h4 className="gradient-text no-hover">Play Me</h4>
            </div>
            <div className="col-md-2 d-none d-md-block">
              <h4>OR</h4>
            </div>
            <div className="col-md-4 d-none d-md-block">
              <h4 className="gradient-text no-hover">Read Me</h4>
            </div>
          </div>
          <div className="row align-items-center">
            <div className="col-md-6 pb-4 pb-md-0">
              <img className="img-fluid video-poster" data-toggle="modal" data-target="#videoModal" src="https://sg.top10bestpaidsurveys.net/images/play-video.jpg" />
            </div>
            <div className="col-md-6">
              <div className="row text-center d-md-none">
                <div className="col-12">
                  <h4>OR</h4>
                </div>
                <div className="col-12 pb-4">
                  <h4 className="gradient-text no-hover">Read Me</h4>
                </div>
              </div>
              <p><strong>1.</strong> It is really important to now check your emails and complete your sign up with ALL of the survey companies you have chosen, before registration closes (the more you sign up to the more you will earn).</p>
              <p><strong>2.</strong> Once signed up to all survey panels, login and start taking surveys. The more you complete the more you will earn.</p>
              <p className="mb-0"><strong>3.</strong> Always check your promotions and spam folders in case the invites have filtered into there. You will also receive new email invites as and when registration is open to other market research companies.</p>
            </div>
          </div>
          <div className="row justify-content-center pt-5">
            <div className="col-md-4 text-center pt-4">
              <h3 className="small mb-4 pb-1">Open your email</h3>
              <a target="_blank" className="btn btn-primary btn-block btn-img mb-3" href="https://www.gmail.com"><img src={gmail} className="pr-3" />Gmail</a>
              <a target="_blank" className="btn btn-primary btn-block btn-img mb-3" href="https://www.icloud.com"><img src={applemail} className="pr-3" />Apple Mail</a>
              <a target="_blank" className="btn btn-primary btn-block btn-img mb-3" href="https://www.outlook.com"><img src={outlook} className="pr-3" />Outlook</a>
              <a target="_blank" className="btn btn-primary btn-block btn-img" href="http://www.yahoomail.com"><img src={yahoomail} className="pr-3" />Yahoo Mail</a>
            </div>
          </div>
        </div>
        <div className="footer text-center">
          <div className="container">
            <div className="row">
            </div>
            <div className="row">
              <div className="col-12 copyright">
                <ul>
                  <li><a href="">Terms &amp; Conditions</a></li>
                  <li><a href="">Privacy Policy</a></li>
                </ul>
                <p>© 2021 Kensto</p>
                <p>*Based on <a className="text-underline" href="">possible earnings</a>. These differ due to panelist demographics and survey companies selected, results vary per person.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}